import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export default function BottomMenu() {
  const pathname = useLocation().pathname
  const navigate = useNavigate()
  const profileData = useSelector((state) => state.profileData)
  const [showBounce, setShowBounce] = useState(false)
  const openGamesSearch = () => {
    setShowBounce(false)
    if (pathname === '/') {
      window.dispatchEvent(new CustomEvent('dos:focus-games-search'))
      return
    }
    navigate('/?focusGamesSearch=1')
  }

  return (
    <>
      <div className='row'>
        <div className='col-12 mobile-footer'>
          <Link to='/' className={`btn border-0 ft-btn ${pathname === '/' ? 'active' : ''}`} onClick={() => setShowBounce(false)}>
            <svg className='icon'>
              <use href='#icon_home'></use>
            </svg>
            <p>Home</p>
          </Link>
          <button type='button' className='btn border-0 ft-btn' onClick={openGamesSearch}>
            <svg className='icon'>
              <use href='#icon_ft-search'></use>
            </svg>
            <p>Search</p>
          </button>
          <Link to='/reports?type=purchase' className={`btn border-0 ft-btn ${pathname.startsWith('/reports') ? 'active' : ''}`}>
            <svg className='icon'>
              <use href='#icon_order'></use>
            </svg>
            <p>Orders</p>
          </Link>
          <button className={`btn border-0 ft-btn ${showBounce ? 'active' : ''}`} onClick={() => setShowBounce(!showBounce)}>
            <svg className='icon'>
              <use href='#icon_chat'></use>
            </svg>
            <p>Support</p>
          </button>
        </div>
      </div>

      {showBounce && (
        <div className='bounce'>
          <a href={`https://wa.me/918329905444/?text=${encodeURIComponent(`Name: ${profileData.name}\nNumber: ${profileData.number}\n`)}`} className='float float-whatsapp bouncel' target='_blank' rel='noreferrer'>
            <svg className='icon'>
              <use href='#icon_whatsapp'></use>
            </svg>
          </a>

          <a href='https://m.me/100226139631005?source=qr_link_share' className='float float-messenger bouncel' target='_blank' rel='noreferrer'>
            <svg className='icon'>
              <use href='#icon_messenger'></use>
            </svg>
          </a>

          <a href='mailto:admin@demonofficialstore.com' className='float float-email bouncel'>
            <svg className='icon'>
              <use href='#icon_email'></use>
            </svg>
          </a>
        </div>
      )}
    </>
  )
}
